import BigNumber from 'bignumber.js'
import React, {useState,useEffect,useCallback} from 'react'
import Web3 from 'web3'
import styled from 'styled-components'
import { provider } from 'web3-core'
import useI18n from 'hooks/useI18n'
import { useWallet } from '@binance-chain/bsc-use-wallet'
import { Heading, Text, Spinner, Link } from '@pancakeswap-libs/uikit'
import Input from 'components/Input'
import FlexLayout from 'components/layout/Flex'
import Pagination from 'components/layout/Pagination'
import { getRanchAddressFromQuery } from 'utils/ranchUtils'
import { useSingleRanch } from '../hooks/useRanches'
import RanchCard from './RanchCard'

const StyledNotification = styled(Text)`
  text-align: center;
  margin-bottom: 20px;
`

const StyledWarning = styled(StyledNotification)`
  color: #ff6a6a;
`

const StyledLink = styled(Link)`
  display: inline;
  font-size: inherit;
  margin-left: 5px;
`

const InputContainer = styled.div`
  padding-top: 20px;
  text-align: center;
  position: relative;
`;

const InputWrapper = styled.div`
  display: inline-block;
  position: relative;
  width: 500px;
  padding-bottom: 30px;

  @media (max-width: 600px) {
    width: 100%;
  }
`

const StyledFont = styled.div`
  font-family: 'Verdana',sans-serif;
`

const Devider = styled.div`
  background-color: ${({ theme }) => theme.colors.textSubtle};
  height: 1px;
  margin: 0 auto 10px;
  width: 100%;
`;

const SearchResultContainer = styled(FlexLayout)`
  padding: 15px 0;
`

const RecentContainer = styled(FlexLayout)`
  padding-top: 20px;
`

const SpinnerOuterContainer = styled.div`
  padding: 10px;
  text-align: center;
`
const SpinnerInnerContainer = styled.span`
  display: inline-block;
  position: relative;
  width: 64px;
`

export interface ExplorerProps {
  ranches: any
  ethereum?: provider
  account?: string
  setPage: any
}

const Explorer: React.FC<ExplorerProps> = ({ ranches, ethereum, account, setPage }) => {
  const TranslateString = useI18n();
  const [ranchAddress, setRanchAddress] = useState(Web3.utils.isAddress(getRanchAddressFromQuery())?getRanchAddressFromQuery():"");
  const { currentPage, pageCount, count } = ranches;

  const searchResult = useSingleRanch(ranchAddress);

  const handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value;
    setAddress(value);
    if (Web3.utils.isAddress(value)) {
      setRanchAddress(value);
    } else {
      setRanchAddress("");
    }
  };

  const renderList = (list) => {
    return list.map((ranch) => (
      <RanchCard
          key={`recentranches_${ranch.address}`}
          ranch = {ranch}
          account = {account}
          ethereum={ethereum} 
      />
    ))
  };

  const [address, setAddress] = useState(getRanchAddressFromQuery() || "");
  const [shouldShowSpinner, setShouldShowSpinner] = useState(false);

  useEffect(() => {
    setShouldShowSpinner(false);
  }, [account, currentPage])

  const onPaginationClick = (newPage) => {
    setShouldShowSpinner(true);
    setPage(newPage);
  }

  const showingSpinner = shouldShowSpinner || !ranches || !ranches.ranches || !ranches.ranches.length;

  return (
    <>
      <StyledWarning>
        {TranslateString(434,'A ranche owner can alter the emission rate, or terminate the ranch prematurely and retrieve the remaining balance. In case of any concerns, you can request the owner to renounce the ranch contract.')}<br/>
        {TranslateString(1334,'It is advisable to conduct your own research on the produced token, as in very rare cases, the token contract may contain some special logic that could result in issues.')}<br/>
        {TranslateString(1335,'When the remaining balance runs out, the ranch will end automatically. Please note that harvesting operates on a first-come, first-served basis, so it is important to harvest in a timely manner.')}
      </StyledWarning>
      <StyledNotification>
        {TranslateString(311,'Read more in the')}<StyledLink external href={`https://docs.benswap.cash/${TranslateString(1330,'')}features/ranches`} bold={false}>{TranslateString(312,'documentation')}</StyledLink>{TranslateString(1107, '.')}
      </StyledNotification>
      <InputContainer>
        <InputWrapper>
          <div>
            <Input
                onChange={handleChange}
                placeholder={TranslateString(436,"Ranch Address")}
                value={address}
            />
          </div>
        </InputWrapper>
      </InputContainer>
      {
        ranchAddress && searchResult && searchResult.length && searchResult[0] && (
          <SearchResultContainer>
            <RanchCard
                ranch = {searchResult[0]}
                account = {account}
                ethereum={ethereum} 
            />
          </SearchResultContainer>
        ) || ""
      }
      <Heading as="h1" size="lg" color="textSubtle" mb="30px" mt="30px" style={{ textAlign: 'center'}}>
          <StyledFont>
            {TranslateString(341,'History')} {count?`(${TranslateString(519,'Total')}: ${count})`:``}
          </StyledFont>
      </Heading>
      <Devider />
      {
        showingSpinner ? (
          <SpinnerOuterContainer><SpinnerInnerContainer><Spinner/></SpinnerInnerContainer></SpinnerOuterContainer>
        ) : (
          <div>
            <RecentContainer>
              {renderList(ranches.ranches || [])}
            </RecentContainer>
            {
              pageCount > 1 ? (
                <Pagination onClick={onPaginationClick} name="historyranches" current={currentPage} count={pageCount} />
              ): ""
            }
          </div>
        )
      }
    </>
  )
}

export default Explorer
